import { Box, Typography } from '@mui/joy';

/**
 * Общие элементы всех рекламных блоков.
 *
 * Пометка «Реклама» и название рекламодателя обязательны по закону
 * о рекламе. Компоненты рисуют их сами, отключить нельзя.
 */

export function AdMark({ sx }) {
    return (
        <Box
            sx={{
                display: 'inline-block',
                bgcolor: 'rgba(0,0,0,0.55)',
                color: '#fff',
                px: 0.7, py: 0.15,
                borderRadius: 'sm',
                fontSize: 10,
                letterSpacing: 0.4,
                lineHeight: 1.6,
                ...sx,
            }}
        >
            РЕКЛАМА
        </Box>
    );
}

export function AdDisclosure({ ad, sx, light }) {
    if (!ad?.brand_name) return null;
    return (
        <Typography
            level="body-xs"
            sx={{
                color: light ? 'rgba(255,255,255,.75)' : 'neutral.500',
                fontSize: 10,
                ...sx,
            }}
        >
            Реклама · {ad.brand_name}
        </Typography>
    );
}

export function AdCta({ text, onClick, fullWidth, size = 'md' }) {
    const paddings = size === 'sm' ? { px: 1.2, py: 0.4 } : { px: 1.8, py: 0.7 };
    return (
        <Box
            component="button"
            onClick={(e) => { e.stopPropagation(); onClick?.(); }}
            sx={{
                ...paddings,
                border: 0,
                cursor: 'pointer',
                bgcolor: 'primary.500',
                color: '#fff',
                borderRadius: 'md',
                fontSize: size === 'sm' ? 12 : 14,
                fontWeight: 600,
                fontFamily: 'inherit',
                width: fullWidth ? '100%' : 'auto',
                transition: '.15s',
                '&:hover': { bgcolor: 'primary.600' },
            }}
        >
            {text || 'Подробнее'}
        </Box>
    );
}